import { INVOICE_TYPE } from "../../../../../../constants/invoiceTypes";

// "Invoice" for the INVOICE typeId; "Proforma" for everything else.
// Mirrors the branching the existing headerTitle uses on this page so
// a row treated as proforma in the breadcrumb is also labelled as one.
const labelForInvoiceType = typeId =>
  typeId === INVOICE_TYPE.INVOICE ? "Invoice" : "Proforma";

// "1,234.50 USD" / "0.00 GBP" — matches the bare-number-plus-code style
// already used in the title row of the invoice detail page header.
// Returns the formatted number with a trailing currency code when one
// is supplied, otherwise just the number.
const formatHeaderAmount = (value, currencyCode = "") => {
  const numeric =
    value == null || value === "" ? 0 : Number.parseFloat(value);
  const formatted = Number.isFinite(numeric)
    ? numeric.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : "0.00";
  return currencyCode ? `${formatted} ${currencyCode}` : formatted;
};

// `approved === -1` is the historical "approved" flag value on invoices
// (matches the existing Approved table cell in the list page).
const isInvoiceApproved = invoice => invoice?.approved === -1;

export { labelForInvoiceType, formatHeaderAmount, isInvoiceApproved };
